'use client';

import React from 'react';
import { useForm } from 'react-hook-form';
import { service_ResponseForNonMemberPortalOfficeHospitalListing } from '@/init/swagger';
import { swaggerClientForNonMember } from '@/init/swaggerClient';
import { apiRequest } from '@/helpers/apiRequestHelper';
import { useSnackbar } from '@/hooks/useSnackbar';
import {
  SearchHospitalNameResolver,
  SearchHospitalNameType,
} from '@/schemas/SearchHospitalNameSchema';

export const useLogic = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [displayListings, setDisplayListings] = React.useState<
    service_ResponseForNonMemberPortalOfficeHospitalListing[]
  >([]);
  const [errorMessage, setErrorMessage] = React.useState('');

  const { openSnackbar } = useSnackbar();

  const method = useForm<SearchHospitalNameType>({
    resolver: SearchHospitalNameResolver,
    defaultValues: {
      portal_office_name: '',
      medical_institution_code: '',
    },
  });

  const search = (): void => {
    setIsLoading(true);
    setErrorMessage('');

    apiRequest({
      requestFunc: () =>
        swaggerClientForNonMember.portalOfficeHospitalListing.postPortalOfficeHospitalListingSearchForNonMember(
          {
            body: {
              medical_institution_code:
                method.getValues('medical_institution_code') || '',
              portal_office_name: method.getValues('portal_office_name') || '',
            },
          },
        ),
      resolveFunc: (res) => {
        // 検索結果が30件以上の場合、backendで30件だけ返され、エラーメッセージが添付される仕様
        if (res.code === 101 && !!res.message) {
          setErrorMessage(res.message);
        }
        setDisplayListings(
          res.portal_office_hospital_listings_for_non_member || [],
        );
        setIsLoading(false);
      },
      rejectFunc: () => {
        openSnackbar('医療機関の検索に失敗しました', 'error');
        setIsLoading(false);
      },
    });
  };

  const handleSearch = () => {
    search();
  };

  return {
    method,
    handleSearch,
    displayListings,
    errorMessage,
    isLoading,
  };
};
